import { useDispatch, useSelector } from "react-redux";
import { setFetchedPrices, setPriceError, setPriceLoading } from "../../../lib/pricesSlice/pricesSlice";
import { useEffect } from "react";
import axios from "axios";
import { selectRaydiumTrades, updateRealTimePrices } from "../../../lib/RaydiumBotSlice/RaydiumBotSlice";

export const useFetchPrices = () => {
  const dispatch = useDispatch();


    const updatePrice = (prices)=> dispatch(updateRealTimePrices(prices))
  const raydiumTrades = useSelector(selectRaydiumTrades)





  const birdEyPrice = async () => {
    const tradesAddy = Object.keys(raydiumTrades) || []
    const options = {
      headers: {
        accept: 'application/json',
        'x-chain': 'solana',
        'X-API-KEY': '44b9bb982b9c42278bb7f108a6688764'
      }
    };


    const res = await axios.get(`https://public-api.birdeye.so/defi/price?address=${tradesAddy[0]}`,options).then((res)=>res.data.data)
    const price = {[tradesAddy[0]]:{
      price:res.value
    }  }
      updatePrice(price)
  }





  const extractEndpoint =  () => {

    const tradesAddy = Object.keys(raydiumTrades) || []

    const ids = ["So11111111111111111111111111111111111111112",...tradesAddy].join(",");

    if (tradesAddy.length === 0){

      let endpoint = `https://api.jup.ag/price/v2?ids=So11111111111111111111111111111111111111112`
      return endpoint
    }else {
      let endpoint = `https://api.jup.ag/price/v2?ids=${ids}`
      return endpoint;
    }


  }



  const getTokenPrice = async () => {

    const tradesAddy = Object.keys(raydiumTrades) || []
    // if (tradesAddy.length === 0) return; // Skip if no addresses

    const ids = ["So11111111111111111111111111111111111111112",...tradesAddy].join(",");

    let endpoint = `https://api.jup.ag/price/v2?ids=So11111111111111111111111111111111111111112`

    dispatch(setPriceError(false));
    dispatch(setPriceLoading(true));

    try {
      const response = await axios.get(endpoint);
      const prices = response?.data?.data || {};
      window.windowPrice = Number(prices["So11111111111111111111111111111111111111112"].price)
      updatePrice(prices)

   // dispatch(setFetchedPrices(prices));
    } catch (err) {
      console.error("Error fetching prices:", err.message);
      dispatch(setPriceError(true));
    } finally {
      dispatch(setPriceLoading(false));
    }
  };

  useEffect(() => {
    // if (Object.keys(raydiumTrades).length === 0) return; // Skip polling if no tokens
    const intervalId = setInterval(() => {
      if (Object.keys(raydiumTrades).length>0) {
        
        birdEyPrice()

      }
      getTokenPrice();
    }, 3000); // Poll every 5 seconds
    return () => clearInterval(intervalId);

  }, [raydiumTrades]);
};